import React, { useState } from 'react'
import {
  Grid,
  TextField,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  useMediaQuery
} from '@mui/material'
import AppButton from './AppButton'
import { isEmpty } from '../utils/AppHelper'
import { useTheme } from '@mui/styles'
import SearchIcon from '@mui/icons-material/Search'

function Search ({ setOnSearch, type }) {
  const theme = useTheme()

  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens
  const [search, setSearch] = useState('')
  const [clearSearch, setClearSearch] = useState(false)

  const handleSearch = search => {
    if (clearSearch) {
      setOnSearch('')
      setSearch('')
      setClearSearch(false)
    } else if (!isEmpty(search)) {
      if (type === 'Jobs') {
        setOnSearch(job, search)
      } else {
        setOnSearch(search)
      }
      setClearSearch(true)
    } else {
      setOnSearch('')
    }
  }

  // search jobs
  const [job, setJob] = useState('title')

  const getPlaceHolder = () => {
    switch (job) {
      case 'title':
        return 'Search by job title/company name - e.g. accountant, frontend developer, etc.'

      case 'keywords':
        return 'Search by skills - e.g. HTML, CSS, javaScript etc.'

      default:
        return ''
    }
  }

  return (
    <Grid
      container
      spacing={2}
      style={{ display: 'flex', justifyContent: 'right' }}
    >
      {/* Drop down */}
      {type === 'Jobs' && (
        <Grid item xs={matches ? 8 : 4}>
          <FormControl fullWidth>
            <Select
              style={{
                // background: theme.palette.background.paper,
                borderRadius: '8px'
                // color: theme.palette.text.disabled
              }}
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              value={job}
              onChange={event => {
                setSearch('')
                setJob(event.target.value)
              }}
              size='small'
            >
              <MenuItem value={'title'}>Job Title/Companies</MenuItem>
              <MenuItem value={'keywords'}>Keywords</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}

      {matches && (
        <Grid item xs={type === 'Jobs' ? 4 : 4}>
          <AppButton
            name={clearSearch ? 'Clear' : 'Search'}
            variant={clearSearch ? 'outlined' : 'contained'}
            onClick={() => {
              handleSearch(search)
            }}
          />
        </Grid>
      )}

      {/* Search Textfield */}
      <Grid
        item
        xs={type === 'Jobs' ? (matches ? 12 : 6) : 8}
        style={{ display: 'flex', justifyContent: 'right' }}
      >
        <TextField
          id='outlined-basic'
          variant='outlined'
          size='small'
          fullWidth
          value={search}
          placeholder={
            type === 'Jobs' ? getPlaceHolder() : 'Search Notification'
          }
          onChange={e => {
            setSearch(e.target.value)
            setClearSearch(false)
          }}
          // sx={{ input: { color: theme.palette.text.disabled } }}
          InputProps={{
            endAdornment:
              type === 'Jobs' ? (
                <InputAdornment position='end'>
                  <SearchIcon />
                </InputAdornment>
              ) : null
          }}
        />
      </Grid>

      {!matches && (
        <Grid item xs={type === 'Jobs' ? 2 : 4}>
          <AppButton
            name={clearSearch ? 'Clear' : 'Search'}
            variant={clearSearch ? 'outlined' : 'contained'}
            onClick={() => {
              handleSearch(search)
            }}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default Search
